import { render, staticRenderFns } from "./FormViewItemInput.vue?vue&type=template&id=2d2bf3f1&scoped=true&v-if=formItem.element"
import script from "./FormViewItemInput.vue?vue&type=script&lang=js"
export * from "./FormViewItemInput.vue?vue&type=script&lang=js"
import style0 from "./FormViewItemInput.vue?vue&type=style&index=0&id=2d2bf3f1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2bf3f1",
  null
  
)

export default component.exports